import { render, staticRenderFns } from "./ClimateHazardsMediumToExtremeChart.vue?vue&type=template&id=cb78520a&scoped=true"
import script from "./ClimateHazardsMediumToExtremeChart.vue?vue&type=script&lang=js"
export * from "./ClimateHazardsMediumToExtremeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb78520a",
  null
  
)

export default component.exports